import { render, staticRenderFns } from "./BriefDetailIcon.vue?vue&type=template&id=cf33ca5c&scoped=true"
import script from "./BriefDetailIcon.vue?vue&type=script&lang=js"
export * from "./BriefDetailIcon.vue?vue&type=script&lang=js"
import style0 from "./BriefDetailIcon.vue?vue&type=style&index=0&id=cf33ca5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf33ca5c",
  null
  
)

export default component.exports